import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

const useStyles1 = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		color: theme.palette.common.white,
	},
	iconDesign: {
		color: theme.palette.common.white,
	},
}));

export const StyledIconButton = withStyles({
	root: {
		padding: "4px",
	},
})(IconButton);

function TablePaginationActions(props) {
	const classes = useStyles1();
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<div className={classes.root}>
			<StyledIconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page">
				{theme.direction === "rtl" ? (
					<LastPageIcon className={classes.iconDesign} />
				) : (
					<FirstPageIcon className={classes.iconDesign} />
				)}
			</StyledIconButton>
			<StyledIconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page">
				{theme.direction === "rtl" ? (
					<KeyboardArrowRight className={classes.iconDesign} />
				) : (
					<KeyboardArrowLeft className={classes.iconDesign} />
				)}
			</StyledIconButton>
			<StyledIconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page">
				{theme.direction === "rtl" ? (
					<KeyboardArrowLeft className={classes.iconDesign} />
				) : (
					<KeyboardArrowRight className={classes.iconDesign} />
				)}
			</StyledIconButton>
			<StyledIconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page">
				{theme.direction === "rtl" ? (
					<FirstPageIcon className={classes.iconDesign} />
				) : (
					<LastPageIcon className={classes.iconDesign} />
				)}
			</StyledIconButton>
		</div>
	);
}

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
};

export default TablePaginationActions;
